import IconContainer from '@/components/IconContainer'

export default function IconGlobe(props) {
  return (
    <IconContainer
      {...props}
      width="20"
      height="20"
      ariaLabel="Globe Icon"
      fill="currentColor"
    >
      <path d="M10 0C4.45 0 0 4.45 0 10C0 15.55 4.45 20 10 20C15.55 20 20 15.5 20 10C20 4.5 15.5 0 10 0ZM16.9 6H13.95C13.65 4.75 13.15 3.55 12.55 2.45C14.45 3.05 15.95 4.35 16.9 6ZM10 2.05C10.85 3.25 11.5 4.6 11.9 6H8.1C8.5 4.55 9.15 3.25 10 2.05ZM2.25 12C2.1 11.35 2 10.7 2 10C2 9.3 2.1 8.65 2.25 8H5.65C5.55 8.65 5.5 9.3 5.5 10C5.5 10.7 5.55 11.35 5.65 12H2.25ZM3.1 14H6.05C6.35 15.25 6.85 16.45 7.45 17.55C5.55 16.95 4.05 15.65 3.1 14ZM6.05 6H3.1C4.05 4.35 5.6 3.05 7.45 2.45C6.8 3.55 6.35 4.75 6.05 6ZM10 17.95C9.15 16.75 8.5 15.4 8.1 14H11.9C11.5 15.45 10.85 16.75 10 17.95ZM12.35 12H7.65C7.55 11.35 7.5 10.7 7.5 10C7.5 9.3 7.55 8.65 7.65 8H12.35C12.45 8.65 12.5 9.3 12.5 10C12.5 10.7 12.45 11.35 12.35 12ZM12.6 17.55C13.2 16.45 13.65 15.25 14 14H16.95C15.95 15.65 14.45 16.95 12.6 17.55ZM14.35 12C14.45 11.35 14.5 10.7 14.5 10C14.5 9.3 14.45 8.65 14.35 8H17.75C17.9 8.65 18 9.3 18 10C18 10.7 17.9 11.35 17.75 12H14.35Z" />
    </IconContainer>
  )
}
